(function () {
  'use strict';

  function rankCandidates(candidates, state) {
    var remaining = state && state.kind === 'remaining' && state.precise === true && Number.isSafeInteger(state.remaining) && state.remaining > 0 ? state.remaining : null;
    return candidates.filter(function (item) { return Number.isSafeInteger(item.price) && item.price > 0; }).slice().sort(function (a, b) {
      if (remaining !== null) {
        var aReaches = a.price >= remaining;
        var bReaches = b.price >= remaining;
        if (aReaches !== bReaches) return aReaches ? -1 : 1;
        if (aReaches && a.price !== b.price) return a.price - b.price;
        if (!aReaches && a.price !== b.price) return b.price - a.price;
      }
      return a.order - b.order;
    });
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { rankCandidates: rankCandidates };
  if (typeof window === 'undefined' || !window.customElements || window.customElements.get('hokema-cart-recommendations')) return;

  class HokemaCartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.ready || !this.closest('#cart-drawer')) return;
      this.ready = true;
      this.drawer = this.closest('#cart-drawer');
      this.cards = Array.from(this.querySelectorAll('[data-hk-rec-card]'));
      this.list = this.querySelector('.hk-cart-recommendations__list');
      this.error = this.querySelector('[data-hk-rec-error]');
      this.status = this.querySelector('[data-hk-rec-status]');
      this.onChange = this.refresh.bind(this);
      this.onSubmit = this.submit.bind(this);
      this.onShipping = (event) => { if (event.target.closest('#cart-drawer') === this.drawer) this.refresh(); };
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onSubmit);
      document.addEventListener('hokema:shipping:updated', this.onShipping);
      this.refresh();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onSubmit);
      document.removeEventListener('hokema:shipping:updated', this.onShipping);
      this.ready = false;
    }

    selection(card) {
      var input = card.querySelector('[data-hk-rec-variant]');
      var option = input && input.tagName === 'SELECT' ? input.options[input.selectedIndex] : input;
      return option ? { id: option.value, price: Number(option.dataset.price), money: option.dataset.money } : null;
    }

    refresh() {
      if (!this.ready) return;
      var shipping = this.drawer.querySelector('hokema-cart-shipping');
      var state = shipping && shipping.state;
      var candidates = this.cards.filter(function (card) { return card.isConnected && !card.dataset.added; }).map((card, order) => {
        var value = this.selection(card);
        if (value) card.querySelector('[data-hk-rec-price]').textContent = value.money;
        return { card: card, order: order, price: value ? value.price : 0 };
      });
      var ranked = rankCandidates(candidates, state);
      ranked.forEach((item, index) => {
        item.card.hidden = index >= 3;
        this.list.appendChild(item.card);
        var note = item.card.querySelector('[data-hk-rec-note]');
        var reaches = state && state.kind === 'remaining' && state.precise === true && item.price >= state.remaining;
        note.textContent = reaches ? this.dataset.targetLabel : '';
        note.hidden = !reaches;
      });
      this.hidden = ranked.length === 0;
    }

    async submit(event) {
      var trigger = event.target.closest('[data-hk-rec-add]');
      var form = trigger && trigger.closest('[data-hk-rec-form]');
      if (!form || !this.contains(form)) return;
      event.preventDefault();
      var card = form.closest('[data-hk-rec-card]');
      var selected = this.selection(card);
      if (!this.ready || this.pending || card.dataset.added || !selected || !/^\d+$/.test(selected.id) || !Number.isSafeInteger(selected.price) || selected.price <= 0) return;
      var button = form.querySelector('[data-hk-rec-add]');
      var originalLabel = button.textContent;
      this.pending = true;
      button.disabled = true;
      button.textContent = this.dataset.savingLabel;
      form.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      try {
        var url = new URL(this.dataset.addUrl, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid cart URL');
        var response = await window.fetch(url.href, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: Number(selected.id), quantity: 1 }] })
        });
        var result = await response.json();
        if (!response.ok || result.status || result.errors) throw new Error('Cart rejected the addition');
        card.dataset.added = 'true';
        card.hidden = true;
        this.status.textContent = this.dataset.successLabel;
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      } catch (error) {
        this.error.textContent = this.dataset.errorLabel;
        this.error.hidden = false;
      } finally {
        this.pending = false;
        button.disabled = Boolean(card.dataset.added);
        button.textContent = originalLabel;
        form.removeAttribute('aria-busy');
        this.refresh();
      }
    }
  }

  window.customElements.define('hokema-cart-recommendations', HokemaCartRecommendations);
})();
